<template>
        <div>
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            @progress="onProgress"
            :html-to-pdf-options ="htmlToPdfOptions"
            ref="html2Pdf"
          >
            <section slot="pdf-content">
              <section class="pdf-item" >
                <div class="col-sm-12">
                  <h3 v-show="actEirAtLoc == 'importPort'" class="text-center text-primary mt-2 mb-1">{{ $t('ReportEIR.eirTitleImport') }}</h3>
                  <h3 v-show="actEirAtLoc == 'pickupDepo'" class="text-center text-primary mt-2 mb-1">{{ $t('ReportEIR.eirTitlePickup') }}</h3>
                  <h3 v-show="actEirAtLoc == 'rels'" class="text-center text-primary mt-2 mb-1">{{ $t('ReportEIR.eirTitleRels') }}</h3>
                  <h3 v-show="actEirAtLoc == 'recv'" class="text-center text-primary mt-2 mb-1">{{ $t('ReportEIR.eirTitleRecv') }}</h3>
                  <h3 v-show="actEirAtLoc == 'cy'" class="text-center text-primary mt-2 mb-1">{{ $t('ReportEIR.eirTitleCY') }}</h3>
                    <div class="ml-2 d-flex flex-row justify-content-between">
                      <div class="text-center ml-5"><img :src="require('../assets/images/conex-logo.png')" alt="conex"></div>                              
                      <div class="mr-5 mt-2">
                        <div class="row">
                            <h5 class="text-dark f-w-800 mx-2">{{ $t('matchTx.date') }} :</h5>
                            <span class="text-dark ml-1">{{ $moment().format(" DD/MMM/YYYY") }}</span>   
                        </div>
                        <div class="row">
                            <h5 class="text-dark f-w-800 mx-2">{{ $t('matchTx.refNo') }} :</h5>
                            <span class="text-dark ml-1">{{refNo }}-EIR</span>   
                        </div>                            
                      </div>
                    </div>                                      
                </div>  
                <div>
                  <b-row class="my-1">
                    <b-col>
                      <h5 class="ml-5">{{$t('matchTx.contNoEir')}} : </h5> 
                      <span class="text-primary ml-5"> {{ selectedItemInfo.contNo }}</span> 
                    </b-col>
                    <b-col>
                      <h5 class="ml-3">{{$t('matchTx.typeSize')}} : </h5> 
                      <span class="text-primary ml-3"> {{selectedItemInfo.contType}} : {{ selectedItemInfo.contSize }} </span> 
                    </b-col>
                    <b-col>
                      <h5 class="ml-3">{{$t('matchTx.tareEir')}} : </h5> 
                      <span class=" text-primary ml-3"> {{selectedItemInfo.tare}} </span> 
                    </b-col>
                  </b-row>
                  <b-row >
                    <b-col>
                      <h5 class="ml-5">{{$t('matchTx.bkgIdEir')}} : </h5> 
                      <span class="text-primary ml-5"> {{ selectedItemInfo.bkgId }}</span> 
                    </b-col>
                    <b-col>
                      <h5 class="ml-3">{{$t('matchTx.agentEir')}} : </h5> 
                      <span class="text-primary ml-3"> {{selectedItemInfo.agent}} </span> 
                    </b-col>
                    <b-col>
                      <h5 class="ml-3">{{$t('matchTx.sealNoEir')}} : </h5> 
                      <span class="text-primary ml-3"> {{selectedItemInfo.sealNo}} </span> 
                    </b-col>                  
                  </b-row>
                  <div class="divider mt-1 mx-5"> </div>   
                  <b-card-group deck>
                    <b-card class="ml-4">
                      <h5 class="text-dark" >{{ $t('matchTx.compNameLocalRelsEir') }}</h5>
                      <span class="text-primary"> {{ selectedItemInfo.compNameLocalRels }}</span>
                      <span class="ml-2 text-primary"> {{ selectedItemInfo.contRelsAddress }}</span>        
                    </b-card>
                    <b-card>
                      <h5 class="text-dark" >{{ $t('matchTx.compNameLocalReqrEir') }}</h5>
                      <span class="text-primary"> {{ selectedItemInfo.compNameLocalReqr }}</span>
                      <span class="ml-2 text-primary"> {{ selectedItemInfo.contReqrAddress }}</span>        
                    </b-card>
                  </b-card-group>
                </div>
                <div>
                  <table class="table table-bordered table-striped mx-4">
                    <tr class="table-warning"><th class="col-sm-4" style="font-size: 14px">{{ $t('approvedTrans.checkpoint') }}</th><th class="gradient-gy">{{$t("approvedTrans.outside")}}</th><th class="gradient-yg">{{$t("approvedTrans.inside")}}</th><th>{{$t("approvedTrans.remark")}}</th></tr>
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.leftSide') }}</td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.left_out" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.left_in" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td><input type="text" v-model="inspData.left_rem" disabled></td>
                    </tr>
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.rightSide') }}</td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.right_out" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.right_in" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td><input type="text" v-model="inspData.right_rem" disabled></td>
                    </tr>
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.door') }}</td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.door_out" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.door_in" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td><input type="text" v-model="inspData.door_rem" disabled></td>
                    </tr>  
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.undercarriage') }}</td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.undercarriage_out" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                      </td>
                      <td><input type="text" v-model="inspData.undercarriage_rem" disabled></td>
                    </tr>                                   
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.roof') }}</td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.roof_out" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td>
                      </td>
                      <td><input type="text" v-model="inspData.roof_rem" disabled></td>
                    </tr>
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.ceiling') }}</td>                                              
                      <td>
                      </td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.ceiling_in" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td><input type="text" v-model="inspData.ceiling_rem" disabled></td>
                    </tr>
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.frontWall') }}</td>                                              
                      <td>
                      </td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.frontWall_in" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td><input type="text" v-model="inspData.frontWall_rem" disabled></td>
                    </tr>
                    <tr class="gradient-wy">
                      <td class="col-sm-4" style="font-size: 12px">{{ $t('approvedTrans.floor') }}</td>                                              
                      <td>
                      </td>                                              
                      <td>
                        <div>
                          <label class="switch">
                            <input type="checkbox" v-model="inspData.floor_in" disabled>
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </td>
                      <td><input type="text" v-model="inspData.floor_rem" disabled></td>
                    </tr>
                  </table>
                </div>                   
                <div class="d-flex flex-row mt-1 col-sm-12">
                  <div class="align-self-strech border border-dark col-sm-12" >
                    <b-form-group>
                      <b-row class="my-2">
                        <h5 class="mx-3">{{ $t('approvedTrans.sumResult') }} : </h5>
                        <span :class="inspData.sumResult == 'reject' ? 'text-danger': inspData.sumResult == 'condPass' ? 'text-warning':'text-success'">
                          {{ $t('approvedTrans.'+ (inspData.sumResult || 'passed')) }}
                        </span>
                      </b-row>
                        <div>
                        </div>                    
                      <b-row v-show="inspData.sumResult == 'condPass'" class="col-sm-12">
                        <h6 class="col-sm-3" >{{ $t('approvedTrans.specifyCond') }} : </h6>
                        <input class="col-sm-9" type="text" v-model="inspData.sum_rem" disabled>
                      </b-row>
                    </b-form-group>
                    <b-card-group>
                      <b-card >
                        <div class="row">
                          <h5 class="text-dark" >{{ $t('matchTx.inspector') }} :</h5>
                          <span class="ml-2 text-primary">{{inspData.inspecter}}</span> 
                          <b-row>
                            <h5 class="ml-5">{{$t('approvedTrans.insprDate')}} : </h5> 
                            <span class="ml-2 text-primary">{{$moment(inspData.inspDate).format("DD-MM-YYYY")}}</span> 
                          </b-row>
                        </div>
                        <div>
                          <span class="text-dark">{{ transCompInfo.compNameLocal }}</span>
                          <span class="ml-2 text-primary">{{ transCompInfo.compAddress  }}</span>                           
                        </div>
                      </b-card>
                    </b-card-group>                    
                  </div>
                </div>                                                                             
              </section>     
              <div class="html2pdf__page-break"/>
              <section class="pdf-item" >
                <div class="col-sm-12 mt-2">
                    <div class="ml-2 d-flex flex-row justify-content-between">
                      <div class="text-center ml-5 my-2"><img :src="require('../assets/images/conex-logoSmall.png')" alt="conex"></div>                      
                      <h2  class="text-center text-dark my-2">{{ $t('matchTx.eir') }}</h2>  
                      <div class="my-2 mx-5" >
                        <div class="row">
                            <h5 class="text-dark f-w-800 ">{{ $t('matchTx.refNo') }} :</h5>
                            <span class="text-dark ml-1">{{refNo }}-EIR</span>   
                        </div>
                        <div class="row">
                          <h5 class="text-dark f-w-800">{{$t('matchTx.contNoEir')}} : </h5> 
                          <span class="text-dark ml-1"> {{ selectedItemInfo.contNo }}</span> 
                        </div>                          
                      </div>
                    </div>                                      
                </div>                                         
              </section>  
              <div class="divider mt-3 mx-5"> </div>                 
              <section class="pdf-item" >
                <div class="col-sm-12">
                  <b-card-group deck>
                    <b-card :img-src="url_1" img-alt="Image#1" class="display-image"></b-card>
                    <b-card :img-src="url_2" img-alt="Image#2" class="display-image"></b-card>
                    <b-card :img-src="url_3" img-alt="Image#3" class="display-image"></b-card>                    
                  </b-card-group>    
                </div>
              </section>   
              <div class="divider mt-3 mx-5"> </div>       
              <section class="pdf-item mt-5" >
                <div class="col-sm-12">
                  <b-card-group deck>
                    <b-card :img-src="url_4" img-alt="Image#4" class="display-image"></b-card>                    
                    <b-card :img-src="url_5" img-alt="Image#5" class="display-image"></b-card>
                    <b-card :img-src="url_6" img-alt="Image#6" class="display-image"></b-card>
                  </b-card-group>   
                </div>
              </section>
              <div v-if="contUrl.length > 6">
              <!-- <div class="html2pdf__page-break"/> -->
              <section class="pdf-item" >
                <div class="col-sm-12 mt-2">
                    <div class="ml-2 d-flex flex-row justify-content-between">
                      <div class="text-center ml-5 my-2">
                        <img :src="require('../assets/images/conex-logoSmall.png')" alt="conex">
                      </div>                      
                      <h2  class="text-center text-dark my-2">{{ $t('matchTx.eir') }}</h2>  
                      <div class="my-2 mx-5" >
                        <div class="row">
                            <h5 class="text-dark f-w-800 ">{{ $t('matchTx.refNo') }} :</h5>
                            <span class="text-dark ml-1">{{refNo }}-EIR</span>   
                        </div>
                        <div class="row">
                          <h5 class="text-dark f-w-800">{{$t('matchTx.contNoEir')}} : </h5> 
                          <span class="text-dark ml-1"> {{ selectedItemInfo.contNo }}</span> 
                        </div>                          
                      </div>
                    </div>                                      
                </div>                                         
              </section>  
              <div class="divider mt-3 mx-5"> </div>                 
              <section class="pdf-item" >
                <div class="col-sm-12">
                  <b-card-group deck>
                    <b-card :img-src="url_7" img-alt="Image#7" class="display-image"></b-card>
                    <b-card :img-src="url_8" img-alt="Image#8" class="display-image"></b-card>             
                  </b-card-group>    
                </div>
              </section>   
              <div class="divider mt-3 mx-5"> </div>       
              <section class="pdf-item mt-5" >
                <div class="col-sm-12">
                  <b-card-group deck>
                    <b-card :img-src="url_9" img-alt="Image#9" class="display-image"></b-card>                    
                    <b-card :img-src="url_10" img-alt="Image#10" class="display-image"></b-card>
                  </b-card-group>   
                </div>
              </section>    
              </div>
            </section>
          </vue-html2pdf>
        </div>
</template>
<script>
export default {
  name: "ReportEIR",
  props: [ "actEirAtLoc","inspData", "refNo", "selectedItemInfo", "transCompInfo", "contUrl"],
  data() {
    return {
      url_1 : '',
      url_2 : '',
      url_3 : '',
      url_4 : '',
      url_5 : '',
      url_6 : '',
      url_7 : '',
      url_8 : '',
      url_9 : '',
      url_10 : '',
    };
  },

  computed: {
      htmlToPdfOptions(){
        return {
          margin: 0,
          filename: `EIR-${this.actEirAtLoc}-${this.refNo}.pdf`,
          image: {
            type: 'png', 
            quality: 0.98
          },
          enableLinks: false,
          html2canvas: {
            scale: 1,
            useCORS: true
          },
        }
      },
  },
  methods: {
    // ฟังก์ชันนี้จะถูกเรียกจาก Main Component
    generate(){
      // console.log(`[ this.contUrl ] =>  ${JSON.stringify(this.contUrl, null, 2)}`)
      // console.log(`genReport`)
      this.url_1 = this.contUrl.length > 0 ? this.contUrl[0].url : '',
      this.url_2 = this.contUrl.length > 1 ? this.contUrl[1].url : '',
      this.url_3 = this.contUrl.length > 2 ? this.contUrl[2].url : '',
      this.url_4 = this.contUrl.length > 3 ? this.contUrl[3].url : '',
      this.url_5 = this.contUrl.length > 4 ? this.contUrl[4].url : '',
      this.url_6 = this.contUrl.length > 5 ? this.contUrl[5].url : '',
      this.url_7 = this.contUrl.length > 6 ? this.contUrl[6].url : '',
      this.url_8 = this.contUrl.length > 7 ? this.contUrl[7].url : '',
      this.url_9 = this.contUrl.length > 8 ? this.contUrl[8].url : '',
      this.url_10 = this.contUrl.length > 9 ? this.contUrl[9].url : '',
      this.$refs.html2Pdf.generatePdf()
    },
    // เมื่อมีการ Progress ตัว Component จะ Emit ต่อไปให้ Parent
    onProgress(progress) {
      this.$emit('progress', progress)
    }
  }
};
</script>
<style scoped>
.divider {
    height: 1px;
    background-color: #0f0f0f;
    margin:5px
}
.display-image {
  width: 100%;
  height: 450px;
  object-fit: scale-down;
  border-radius: 8px;
  background-color: #f5f5f5;
}

 .gradient-gy {
   background: linear-gradient(135deg, green, yellow);
 }
 .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }

 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
  background-color: #ccc; /* Example: Gray when off */
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

/* Change background color of the slider when checked (ON state) */
input:checked + .slider {
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
  background-color: #2196F3; /* Example: Blue when on */
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 /* .dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
} */

/* .image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; 
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; 
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
} */
.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
/* .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
} */

/* .scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
} */
</style>